export class Setting {
	id: number;
	settingKey: string;
	settingValue: string;
}
